import { ActionTree, Module, MutationTree } from "vuex";
import { RootState } from "../../store.interface";
import { TimeStore } from "@/shared/interfaces/TimeStore.interface";

import { MILLISECONDS_PER_MINUTES } from "@/shared/scripts/helpers/date";

const state = {
    now: (new Date()),
    intervalTimer: null,
};

const mutations: MutationTree<TimeStore> = {
    now: function(state) {
        state.now = new Date();
    },

    setIntervalTimer: function(state, callback) {
        state.intervalTimer = setInterval((() => {
            if (callback) {
                callback();
            }
        }) as TimerHandler, MILLISECONDS_PER_MINUTES * 3);
    },

    clearIntervalTimer: function(state) {
        if (state.intervalTimer) {
            clearInterval(state.intervalTimer);
        }
    }
};

const actions: ActionTree<TimeStore, RootState> = {
    pollNow: function({ commit, state }) {
        if (!state.intervalTimer) {
            commit("setIntervalTimer", () => commit("now"));
        }
    },

    clearPollNow: function({ commit }) {
        commit("clearIntervalTimer");
    },
};

const time: Module<TimeStore, RootState> = {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
};

export default time;
